export const SET_ERROR = 'SET_ERROR';
export const SET_LOGOUT = 'SET_LOGOUT';

export const setError = payload => ({ type: SET_ERROR, payload });
export const setLogout = payload => ({ type: SET_LOGOUT, payload });